<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="750">
            <v-card
                flat
                color="light">
                <v-toolbar color="primary" dense dark flat>
                    <v-toolbar-title>Incoming Payment</v-toolbar-title>
                </v-toolbar>
                <!-- <v-card-title>{{ this.$t('incoming_payment') }}</v-card-title> -->
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else class="mt-4">
                    <v-form
                        v-model="valid"
                        ref="form">
                        <v-row>
                            <v-col>
                                <p-date-picker
                                    :outlined="true" 
                                    background-color="white" 
                                    :disabled="true" 
                                    :label="$t('date')"
                                    v-model="form.created_at" 
                                    :hide="true"
                                ></p-date-picker>
                            </v-col>
                            <v-col>
                                <p-date-picker
                                    :label="$t('document_date')" 
                                    background-color="white" 
                                    :outlined="true" 
                                    v-model="form.date" 
                                    :hide="true">
                                </p-date-picker>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <customer-search
                                    v-model="form.customer_id"
                                    :label="$t('customer')"
                                    item-text="display_name"
                                    item-value="id"
                                    :rules="rules.required"
                                    hide-details="auto"
                                    :outlined="true"
                                    background-color="white">
                                </customer-search>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-select
                                    outlined
                                    background-color="white"
                                    dense
                                    v-model="form.payment_mode_id"
                                    :items="paymentModes"
                                    :rules="rules.required"
                                    @change="handleModeChange"
                                    item-text="name"
                                    item-value="id"
                                    hide-details="auto"
                                    :menu-props="{down: true, offsetY: true}"
                                    :label="$t('mode')">
                                </v-select>
                            </v-col>
                            <!-- <v-col cols="6">
                                <v-text-field
                                    label="BT Reference"
                                    outlined
                                    v-if="form.payment_mode_id == 3"
                                    hide-details="auto"
                                    background-color="white"
                                    dense
                                    :rules="[isRequired, isNumeric]">
                                </v-text-field>
                            </v-col> -->
                        </v-row>
                        <v-row>
                            <v-col>
                                 <p-currency-select
                                    outlined
                                    background-color="white"
                                    v-model="form.currency_id" 
                                    :rules="rules.required"
                                    @get:abbreviation="abbreviation = $event"
                                    @change="exchange = defaultExchange"
                                    hide-details="auto"
                                    >
                                </p-currency-select>
                            </v-col>
                            <v-col>
                                <v-select
                                    outlined
                                    background-color="white"
                                    :rules="rules.required"
                                    :items="ledgerFiltter"
                                    dense
                                    item-value="id"
                                    item-text="displayName"
                                    :loading="loading.ledger"
                                    hide-details="auto"
                                    v-model="form.ledger_id"
                                    :menu-props="{down: true, offsetY: true}"
                                    :label="$t('deposit_to')">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    outlined
                                    background-color="white"
                                    :prefix="abbreviation ? abbreviation : null"
                                    :label="$t('amount')"
                                    v-model="form.amount"
                                    :rules="[isRequired, isNumeric]"
                                    dense>
                                </v-text-field>
                            </v-col>
                            <v-col>
                               <v-text-field 
                                    outlined
                                    background-color="white"
                                    prefix="SDG"
                                    label="Base Amount"
                                    v-model="form.base_amount"
                                    :hint="baseAmountHint"
                                    persistent-hint
                                    v-if="baseCurrencyId != form.currency_id"
                                    dense
                                    append-icon="mdi-refresh"
                                    @change="exchange = customExchange"
                                    @click:append="resetBaseAmount">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <!-- <v-row>
                            <v-col>
                                <v-switch 
                                    dense
                                    hide-details="auto"
                                    :label="$t('on_account')" 
                                    v-model="form.on_account">
                                </v-switch>
                            </v-col>
                            <v-col></v-col>
                        </v-row> -->
                        <!-- <br  v-if="!form.on_account">
                        <v-data-table
                            v-if="!form.on_account"
                            dense
                            :headers="header.incomingLines"
                            show-select
                            hide-default-footer
                            disable-pagination
                            @item-selected="itemSelected"
                            v-model="selected.incomingLines"
                            :items="incomingLines">
                            <template v-slot:[`item.amount`]="{ item }">
                                <v-text-field 
                                    :disabled="!isSelected(item.id)"
                                    dense
                                    hide-details
                                    :rules="rules.number"
                                    v-model.number="item.amount">
                                </v-text-field>
                            </template>
                            <template
                                v-slot:[`body.append`]>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ $t('total_amount_due') }}</td>
                                    <td>{{ total }}</td>
                                </tr>
                            </template>
                        </v-data-table> -->
                        <v-row>
                            <v-col cols="6">
                                <v-textarea
                                    outlined
                                    background-color="white"
                                    rows="3"
                                    :rules="rules.required"
                                    hide-details="auto"
                                    v-model="form.description"
                                    :label="$t('memo')">
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <!-- :disabled="!valid" -->
                    <v-btn 
                        :loading="loading.submit" 
                        @click="submit"  
                        text>
                        {{ $t('save_btn') }}
                    </v-btn>
                    <v-btn @click="close" text>{{ $t('close_btn') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <retry-dialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit">
        </retry-dialog>
    </div>
</template>

<script>

import moment from 'moment';
import { mapActions, mapState } from 'vuex';
// import { isEmpty } from 'lodash';
import { formatMoney, formatNumber } from 'accounting';

import service from '@/services/service';
import handlerError from '@/utils/handlerError';
import { getPayment, storePayment, updatePayment } from '../../services/sales/payment';
import { getDpk } from '../../services/sales';
import { searchExchangeRates } from "./../../services/ledger/exchangeRates";

import PDatePicker from '../common/PDatePicker.vue'
import PCurrencySelect from '@/components/common/PCurrencySelect';
import RetryDialog from '../common/RetryDialog.vue';
import CustomerSearch from '../searchComponents/CustomerSearch.vue';
import { getCustomer } from '../../services/sales/customer';
import { isRequired, isNumeric } from './../../utils/validations'

export default {
    name: 'IncomingPayment',
    components: {
        PDatePicker, 
        PCurrencySelect, 
        RetryDialog,
        CustomerSearch,
    },
    props: {
        id: Number,
        idCustomer: Number,
        amountInvoice: Number
    },
    data() {
        return {
            valid: false,
            display: true,
            abbreviation: null,
            depositType: [],
            exchange: 1,
            // TODO: change this from api.
            baseCurrencyId: 1,
            form: {
                date: new moment().format("YYYY-MM-DD"),
                created_at: new moment().format("YYYY-MM-DD"),
                customer_id: null,
                ledger_id: null,
                amount: null,
                base_amount: null,
                currency_id: null,
                on_account: true,
                description: null,
                mode_id: null,
            },
            accounts: [],
            selected: {
                incomingLines: [],
               
            },
            deposit: [],
            loading: {
                data: false,
                submit: false,
            },

            header: {
                incomingLines: [
                    { text: this.$t('code_'), value: 'code', sortable: false },
                    { text: this.$t('date'), value: 'date', sortable: false },
                    { text: this.$t('type_account'), value: 'type', sortable: false },
                    { text: this.$t('total'), value: 'total' , sortable: false},
                    { text: this.$t('amount'), value: 'amount', sortable: false },
                ]
            },
            incomingLines: [
                { id: 1 ,code: 'CA00012', date: '2021/3/21', type: 'Invoice', total: 25000, amount: null },
                { id: 2,code: 'CA00022', date: '2021/3/21', type: 'Invoice', total: 25000, amount: null }
            ],
            rules: {
                required: [
                    v => !!v || this.$t('rules_required')
                ],
                number: [
                    v => !isNaN(v) || this.$t('rules_numeric')
                ]
            },
            exchangeRates: [],
            // exchangeRates: [
            //     {
            //         currency_id: 1,
            //         abbreviation: "SDG",
            //         rate: 1
            //     },
            //     {
            //         currency_id: 2,
            //         abbreviation: "AED",
            //         rate: 90
            //     },
            //     {
            //         currency_id: 3,
            //         abbreviation: "USD",
            //         rate: 375
            //     }
            // ],
            isRequired,
            isNumeric
        }
    },
    computed: {
        ...mapState('sales/paymentMode', ["paymentModes"]),
        ...mapState('sales/customer', ["customerSearch"]),
        notEditMode() {
            return !this.id;
        },
        editMode() {
            return !this.notEditMode;
        },
        total() {
            return this._.sumBy(this.selected.incomingLines, line => {
                if(typeof(line.amount) == 'number') return Number(line.amount);
                else return 0;
            });
        },
        mode() {
            return this.paymentModes.find(each => each.id == this.form.payment_mode_id).code; 
        },
        ledgerFiltter() {
            return this.accounts.filter(each => each.currency_id == this.form.currency_id)
        },
        defaultExchange() {
            // if(isEmpty(this.form.currency_id)) return 0;
            let exchange = this.exchangeRates.find(each => each.currency_id == this.form.currency_id);
            return exchange === undefined ? 0 : exchange.rate;
        },
        customExchange() {
            return parseFloat(this.form.base_amount) / parseFloat(this.form.amount);
        },
        baseAmount() {
            // if(isEmpty(this.exchange)) return 0;
            return this.form.amount * this.exchange;
        },
        baseAmountHint() {
            // if(isEmpty(this.form.base_amount)) return null;
            return `${formatMoney(this.form.amount, "USD", 2)}@${formatNumber(this.exchange, 6)}`;
        }
    },
    watch: {
        'form.on_account': {
            handler() {
                if(this.form.on_account) {
                    this.clearLinesAmount();
                    this.clearSelectedItem();
                } 
            },
            deep: true
        },
        idCustomer: {
            handler() {
                if(this.idCustomer) {
                    this.form.customer_id = this.idCustomer;
                }
            }
        },
        'form.amount': {
            handler() {
                this.form.base_amount = this.form.amount * this.exchange;
            }
        },
        exchange() {
            this.form.base_amount = Math.ceil(this.baseAmount, 2);
        }
    },
    methods: {
        ...mapActions('sales/paymentMode', ["fetchPaymentModes"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        ...mapActions("sales/customer", ["setCustomersFromSearch"]),
        customerExistInStore(customerId) {
            return this.customerSearch.indexOf(this.customerSearch.find(each => each.id == customerId)) === -1 ? false : true ;
        },
        getCustomerData(customerId) {
            // if customer is not available in store fire http request and set it in the store.
            if(this.customerExistInStore(customerId)) return;
            getCustomer(customerId).then(response => this.setCustomersFromSearch([response.data]));
        },
        async createdDataFetch() {
            try {
                this.loading.data = true;
                await Promise.all([this.fetchPaymentModes()]);
                if(this.editMode) {
                    let response = await getPayment({id: this.id});
                    this.form = response.data;
                    this.form.created_at = new moment(this.form.created_at).format("YYYY-MM-DD");
                    this.getCustomerData(this.form.customer_id);
                    this.getLedgerAccount();
                    this.exchange = this.customExchange;
                } else {
                    this.exchange = this.defaultExchange;
                    getDpk().then(response => this.dpk = response.data.key);
                }
                this.loading.data = false;
                let exchangeRateResp = await searchExchangeRates({date: this.form.date});
                this.exchangeRates = exchangeRateResp.data.rates;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch", message});
            }
        },
        addLineSelectedToForm() {
            if(this.selected.incomingLines.length) this.form.incomingLines = this.selected.incomingLines;
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            } else if(params.target == "getLedgerAccount") {
                if(params.retry) this.getLedgerAccount();
            }
        },
        depositTypes() {
            let is_bank_transfer = this.paymentModes.find(each => each.id == this.form.payment_mode_id).is_bank_transfer;
            if(is_bank_transfer) {
                this.depositType =  this.deposit.filter(each => each.is_cash == false); 
            } else {
                this.depositType = this.deposit.filter(each => each.is_cash == true); 
            }
        },
        isSelected(val) {
            let item = this.selected.incomingLines.filter(each => each.id == val);
            if(item.length == 1) return true;
            else { 
                return false;
            }  
        },
        async submit(){
            if(!this.$refs.form.validate()) return;
            this.addLineSelectedToForm();
            this.loading.submit = true;
            if(this.notEditMode) {
                // await service('/sales/payments', 'post', this.form)
                await storePayment({data: this.form, dpk: this.dpk})
                    .then(() => {
                        this.loading.submit = false;
                        this.setSnackBars({ message: this.$t("record_save_success") });
                        this.$emit('update');
                        this.close();
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        this.setSnackBars({ color: 'error', message: error.response.data.message});
                    });
            } else {
                    updatePayment({id: this.id, data: this.form})
                    .then(() => {
                        this.loading.submit = false;
                        this.setSnackBars({ message: this.$t("record_update_success") });
                        this.$emit('update');
                        this.close();
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        this.setSnackBars({ color: 'error', message: error});
                    });
            }
        },
        getLedgerAccount() {
            this.loading.ledger = true;
            service('/banking/ledger-accounts', 'get', '', {mode: this.mode})
                .then((response) => {
                    this.accounts = response.data;
                    this.loading.ledger = false;
                })
                .catch((error) => {
                    this.loading.ledger = false;
                    handlerError(error.response.data);
                    // let message = error.response ? error.response.data.message : error;
                    // this.$refs.retryDialog.open({target:"getLedgerAccount", message});
                });

        },
        setMessage(val) {
            console.log('val', val,  this._.size(val.errors));
            // let counterError = this._.size(val.errors);
            if(val.errors) {
                // val.errors.forEach((error) => {
                    this.setSnackBars({ color: 'error', message:  val.errors['customer_id'][0]});
                // })
            }
        },
        itemSelected(params) {
            if(!params.value) {
                this.incomingLines.find(each => each.id == params.item.id).amount = null;
            } 
        },
        clearLinesAmount() {
            this.incomingLines.forEach(line => {
                                                line.amount = null;
                                            });
        },
        clearSelectedItem() {
            this.selected.incomingLines = [];
        },
        close() {
            this.$emit('close');
        },
        resetBaseAmount() {
            this.exchange = this.defaultExchange;
            // this.form.base_amount = this.baseAmount;
        },
        handleModeChange() {
            this.getLedgerAccount();
            this.form.ledger_id = null;
        }
    },
    created() {
        this.createdDataFetch();
        if(this.idCustomer) {
            this.form.customer_id = this.idCustomer;
            this.form.amount = this.amountInvoice;
        }
    }
}
</script>

<style>

</style>